import React, { FC } from 'react';
import Heading from '../heading';

const Treasury4: FC = () => {
  return (
    <section>
      <div className="work-item container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="project-title">
              <h3>Treasury4</h3>
              <h4>A treasury management platform that unifies corporate cash visibility, liquidity forecasting, payments, and legal entity data into a single connected system.</h4>
            </div>
            <p><strong>Role:</strong> Software Engineer - Full Stack</p>
          </div>
          <div className="col-xs-6 col-md-3">
            <p><strong>Technologies Used:</strong></p>
            <ul>
              <li>C# / .NET Core, Entity Framework Core</li>
              <li>TypeScript / JavaScript</li>
              <li>React.js</li>
              <li>SQL Server / Azure SQL</li>
            </ul>
          </div>
          <div className="col-xs-6 col-md-3">
            <p><strong>Cool stuff:</strong></p>
            <ul>
              <li>Microsoft Azure</li>
              <li>Azure Service Bus</li>
              <li>MassTransit (pub/sub, topics, and queues)</li>
              <li>RESTful APIs</li>
              <li>Direct Bank APIs</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <p className="text-center"><strong>Check it out in the wild:</strong> <a href="https://www.treasury4.com/" target="_blank">Treasury4.com</a></p>
          </div>
        </div>
        <div className="row center-xs">
          <div className="col-xs-12 col-sm-10">
            <img src="/treasury4.png" alt="Treasury4.com" className="featured-project-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Treasury4;
